import { Inject, Injectable } from '@angular/core';
import { TAnalyticsEnvironmentVars } from '@monorepo/types';

export const AnalyticsEndPoints = {
  GET_PLANI8_IN_HOUSE_CONFIG: '/plani8_analytics/config',
  SEARCH_ANALYTICS: '/v3/search',
};

@Injectable()
export class AnalyticsEnvironmentService {
  #API_URL: string;
  constructor(@Inject('analyticsEnvironment') envValues: TAnalyticsEnvironmentVars) {
    if (envValues.data_gateway !== undefined && envValues.host !== undefined && envValues.protocol !== undefined) {
      this.#API_URL = envValues.protocol + envValues.host + envValues.data_gateway;
    } else {
      throw new Error('AnalyticsEnvironmentService: Missing environment variables');
    }
  }

  public getUrlFromEnv(arg: keyof typeof AnalyticsEndPoints): string {
    return this.#API_URL + AnalyticsEndPoints[arg];
  }
}
